__turbopack_context__.v({
  "container": "DropdownMenu-module-scss-module__50OLEW__container",
  "icon": "DropdownMenu-module-scss-module__50OLEW__icon",
  "list": "DropdownMenu-module-scss-module__50OLEW__list",
  "option": "DropdownMenu-module-scss-module__50OLEW__option",
  "optionSelected": "DropdownMenu-module-scss-module__50OLEW__optionSelected",
  "popup": "DropdownMenu-module-scss-module__50OLEW__popup",
  "positioner": "DropdownMenu-module-scss-module__50OLEW__positioner",
  "positionerElevated": "DropdownMenu-module-scss-module__50OLEW__positionerElevated",
  "select": "DropdownMenu-module-scss-module__50OLEW__select",
  "selectHasError": "DropdownMenu-module-scss-module__50OLEW__selectHasError",
  "trigger": "DropdownMenu-module-scss-module__50OLEW__trigger",
});
